<dw-meta-data-grid [item]="item" [configKeyPart]="configKeyPart" [preferences]="gridPreferences" [filters]="filter"></dw-meta-data-grid>
